import { Injectable } from '@angular/core';
import { BBService } from 'bookingbug-core-js';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { FormGroup } from '@angular/forms';
@Injectable({
	providedIn: 'root',
})
export class DatastoreService {

	constructor(
		private router: Router
	) {
		this.isCitizenship$ = this.citizenship.asObservable();

	}

	// new function called agentRestart
	agentRestart() {
		// clear all localstorage
		localStorage.clear();

		//clear all session storage
		sessionStorage.clear();

		//clear variables
		this.startQuestions = null;
		this.type_of_appointment = null;
		this.appointment_type = null;
		this.totalCost = null;
		this.pageContent = null;
		this.reference = null;
		this.isCitizenshipRoute = null;
		this.dateCapInitDate = null; // used to cap calendar dates one year from entered date

		// client details
		this.booker_first_name = null;
		this.booker_last_name = null;
		this.booker_email = null;
		this.booker_phone = null;
		this.lookupResponses = [];
		this.costBreakDown = null;
		this.selectedAddress = null;
		this.setService = null;
		this.setResource = null;
		this.extraDuration = 0; // obtained from questions
		this.childDob = false;
		this.bookingQuestions = [];
		this.unselectedLocations = [];
		this.bookingForm = null;
		this.companyAnswers = null;
		this.selectedDate = null;
		this.selectedSlot = null;
		this.selectedResource = null;
		this.selectedService = null; //used only to store the service incase we switch to the alt one
		this.selectedDepartment = null; //used only to store the service incase we switch to the alt one
		this.locations = [];
		this.bookingAnswers = null;

		if (this.isCitizenshipRoute) {
			this.router.navigate(['/start/citizenship']);
			return;
		} else {
			this.router.navigate(['/agent']);
			return;
		}
	}

	startQuestions: any;
	type_of_appointment: any;
	appointment_type: any;
	public totalCost: any;
	public pageContent: any;

	public firstSlotAnalytic: any;
	public firstSlotAnalyticKey: string;

	public reference: any;
	public isCitizenshipRoute: any;
	public dateCapInitDate: any; // used to cap calendar dates one year from entered date

	public serviceQuestionSchema: Record<string, any>;
	public selectedSchema: string;
	companyQuestionsForm: FormGroup = new FormGroup({});

	// client details
	public booker_first_name: any;
	public booker_last_name: any;
	public booker_email: any;
	public booker_phone: any;
	public lookupResponses: any[] = [];
	public costBreakDown: any;
	public selectedAddress: any;

	public setService: any;
	public setResource: any;
	public staff_set: any;
	public autoSelectedStaff: any;

	public extraDuration = 0; // obtained from questions

	public childDob: any = false;

	public bookingQuestions = [];

	public unselectedLocations = [];

	public bookingForm;
	public companyAnswers;

	public selectedDate;

	public selectedSlot;

	public selectedResource;

	public selectedService; //used only to store the service incase we switch to the alt one
	public selectedDepartment; //used only to store the service incase we switch to the alt one

	public locations = [];

	public bookingAnswers;

	public customerDetailsForm;

	public client;

	public clientCreated = false;

	public address;

	public latitude;

	public longitude;

	public endSlot;

	public customerQuestions;

	public companyQuestions;

	public address1;

	public selectedLocation;

	public booking;

	public totalPrice;

	public adminJourney = false;

	public adminAuthToken = '';

	public purchase: any;

	public serviceBookingType: any;

	public selectedSuggestion: any;

	public config: any;

	public serviceFees: any;

	public _extraItems = [];

	public ceremonyDate: any;

	public deathDate: any;

	public mccdRegDate: any;

	public journeyRoute: string;

	public skipLocationsPage = false;

	public postageCounts: any;

	public citizenshipFees = {
		'mon_fri_9_5': {
			'individual': "f5c129e2-d23d-4940-945a-6a5c6175338b",
			'family': "461dd2f7-7ba1-4267-a044-0cc5ccba759f",
		},
		'mon_fri_after_5': {
			'individual': "3f667274-a6d3-4931-981a-15f702ebdd7b",
			'family': "ec96b6ee-118c-4165-8240-17b4f14162a4"
		},
		'sat': {
			'individual': "78ea1458-cac9-43b1-84f6-59d75d8f186f",
			'family': "e1752c06-3f94-409e-9dd5-286bdb1d88d9"
		},
		'sun': {
			'individual': "534e1659-880c-467e-a951-f56fdd2e6ee7",
			'family': "5d8e1c77-aae1-4648-adef-27c19268f168"
		}
	};
	public citizenshipGroupFees = {
		'mon_fri_9_5': {
			'individual': "cfbbf582-e59f-4ec2-9da2-42442b311951",
			'family': "fc896f8e-cec7-44ba-829e-3f52ec23aa85",
		},
		'mon_fri_after_5': {
			'individual': "f0cb3054-c873-44c3-97f3-d27f7ee4e927",
			'family': "8a5fd0fa-b9cf-4e65-9006-2bbdaf43531a"
		},
		'sat': {
			'individual': "202dbac0-6f52-4a36-a746-8f9c2047c68b",
			'family': "8f6642ec-a723-46bd-becc-acc795daa385"
		},
		'sun': {
			'individual': "37f5500f-ed5a-44af-a4ad-edc8b7602837",
			'family': "33cd4286-88e4-4ef1-95b5-2b90bb5a98e2"
		}
	};
	public citizenshipKey = '';

	public familyCitizenshipBooking = false;

	public groupCitizenshipBooking = false;

	public citizenshipExtraItem;

	notify: Subject<boolean> = new Subject<boolean>();
	onNotify(event) {
		this.notify.next(true);
	}

	private addFeesSubject = new BehaviorSubject<any>(null);
	addFees$ = this.addFeesSubject.asObservable();
	triggerAddFees(fees: any) {
		this.addFeesSubject.next(fees);
	}

	public citizenship: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public isCitizenship$: Observable<boolean>;
	updateCitizenship(val: boolean) {
		this.citizenship.next(val);
	}

	public certificateStore: any;

	public applicationStore:
		| {
			formData: Record<string, string> | undefined;
			applicationType: string;
			formId: string;
			applicationNumber: string | undefined;
		}
		| undefined;
}
